import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import {
  getAllCheckIn,
  getMobileAppMySchedule,
  getMobileAppReservastions,
} from "../../actions/axios-actions";
import OrderTableData from "./ReservationTableData";
import Breadcrumbs from "../../CommonElements/Breadcrumbs";
import TimelineTab from "./TimelineTab";
import ActiveTabs from "./ActiveTabs";
import AllCheckIn from "./AllCheckIn";
import DailyCheckIn from "./DailyCheckIn";
import momentTZ from "moment-timezone";
import MyStayTableData from "./MyStayTableData";
import moment from "moment-timezone";

export const dateFormat = (data) => {
  const inputDate = new Date(data);
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  const convertedDate = inputDate.toLocaleDateString("en-US", options);

  const parts = convertedDate.split("/");
  const formattedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;

  return formattedDate;
};

const MobileAppReservationContain = () => {
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [myActiveTab, setMyActiveTab] = useState("Reservations");
  const [checkInData, setCheckInData] = useState([]);
  const [myTotalRows, setMyTotalRows] = useState(0);
  const [myPerPage, setMyPerPage] = useState(10);
  const [myCurrentPage, setMyCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(
    new Date(momentTZ().tz("US/Pacific").startOf("day"))
  );
  const [endDate, setEndDate] = useState(
    new Date(momentTZ().tz("US/Pacific").startOf("day"))
  );
  const [myStayStartDate, setMyStayStartDate] = useState(new Date());
  const [myStayEndDate, setMyStayEndDate] = useState(new Date());
  const [fieldSelected, setFieldSelected] = useState(false);
  const [myStayFromSelectedObj, setMyStayFromSelectedObj] = useState({});
  const [filterByActivity, setfilterByActivity] = useState({});

  const [sortSelected, setSortSelected] = useState(false);
  const [filterSelected, setFilterSelected] = useState(false);
  const [dailyCheckInFltr, setDailyCheckInFltr] = useState({});

  useEffect(()=>{
    setFilterSelected({ value: "In-house", label: "In-house" })
  },[myActiveTab])

  let OrderTableDataProps = {
    data,
    setData,
    loading,
    setLoading,
    totalRows,
    setTotalRows,
    perPage,
    setPerPage,
    currentPage,
    setCurrentPage,
    searchText,
    setSearchText,
  };

  let AllCheckInDataProps = {
    checkInData,
    setCheckInData,
    loading,
    setLoading,
    searchText,
    setSearchText,
    myTotalRows,
    setMyTotalRows,
    myPerPage,
    setMyPerPage,
    myCurrentPage,
    setMyCurrentPage,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    dailyCheckInFltr,
    setDailyCheckInFltr,
  };

  const handleSearch = (e) => {
    e.preventDefault();

    getMobileAppReservastions(setData, setLoading, setTotalRows, {
      searchText,
      fieldSelected,
      sortSelected,
      inforStatus: filterSelected.value,
    });
  };
  const handleResFilter = (filterObj) => {
    console.log(filterObj);
    setFilterSelected(filterObj);
    getMobileAppReservastions(setData, setLoading, setTotalRows, {
      searchText,
      fieldSelected,
      sortSelected,
      inforStatus: filterObj.value,
      size:perPage
    });
  };

  const handleFromFilter = (filterObj) => {
    setMyStayFromSelectedObj(filterObj);
  };

  const handleFilterByActivity = (filterObj) => {
    setfilterByActivity(filterObj);
  };

  const fetchData = ({ searchText = "", startDate, endDate }) => {
    setData([]);
    const filters = {
      searchText: searchText,
      startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
      endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
      stayFrom:
        myStayFromSelectedObj?.value !== "all"
          ? myStayFromSelectedObj?.value
          : null,
      activity:
        filterByActivity?.value !== "all" ? filterByActivity?.value : null,
      currentPage: currentPage,
      perPage: perPage,
    };

    getMobileAppMySchedule(setData, setLoading, setTotalRows, filters);
  };

  const updateDateRange = (searchText, start, end) => {
    setMyStayStartDate(start);
    setMyStayEndDate(end);
    fetchData({ searchText: searchText, startDate: start, endDate: end });
  };

  const myhandleSearch = (e) => {
    e.preventDefault();
    if (myActiveTab === "My-Stay") {
      fetchData({
        searchText: searchText,
        startDate: myStayStartDate,
        endDate: myStayEndDate,
      });
    } else {
      getAllCheckIn(
        setCheckInData,
        setLoading,
        dateFormat(startDate),
        dateFormat(endDate),
        searchText,
        setMyTotalRows,
        myCurrentPage,
        myPerPage
      );
    }
  };
  const handlefieldChange = (option) => {
    setFieldSelected(option.value);
  };
  const handleSortChange = (option) => {
    setSortSelected(option.value);
  };

  useEffect(() => {
    if (myActiveTab !== "My-Stay") {
      setfilterByActivity({ value: "all", label: "All" });
      setMyStayFromSelectedObj({ value: "all", label: "All" });
      setMyStayStartDate(new Date());
      setMyStayEndDate(new Date());
    }

    if (myActiveTab === "My-Stay") {
      fetchData({
        startDate: myStayStartDate,
        endDate: myStayEndDate,
      });
    }
  }, [myActiveTab]);

  return (
    <Fragment>
      <Breadcrumbs parent="Pages" title="Reservations">
        <TimelineTab
          handleSearch={
            myActiveTab === "Reservations" ? handleSearch : myhandleSearch
          }
          changeSearchText={(e) => setSearchText(e.target.value)}
          searchText={searchText}
          myActiveTab={myActiveTab}
        />
      </Breadcrumbs>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <ActiveTabs
                myActiveTab={myActiveTab}
                setMyActiveTab={setMyActiveTab}
                //
                handleSearch={
                  myActiveTab === "Reservations" ? handleSearch : myhandleSearch
                }
                changeSearchText={(e) => setSearchText(e.target.value)}
                searchText={searchText}
                setSearchText={setSearchText}
                handlefieldChange={handlefieldChange}
                handleSortChange={handleSortChange}
                handleResFilter={handleResFilter}
                handleFromFilter={handleFromFilter}
                handleFilterByActivity={handleFilterByActivity}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setMyStayStartDate={setMyStayStartDate}
                setMyStayEndDate={setMyStayEndDate}
                myStayStartDate={myStayStartDate}
                myStayEndDate={myStayEndDate}
                loading={loading}
                setLoading={setLoading}
                setCheckInData={setCheckInData}
                dateFormat={dateFormat}
                setMyTotalRows={setMyTotalRows}
                myCurrentPage={myCurrentPage}
                myPerPage={myPerPage}
                perPage={perPage}
                dailyCheckInFltr={dailyCheckInFltr}
                setDailyCheckInFltr={setDailyCheckInFltr}
                updateDateRange={updateDateRange}
                myStayData={data}
                myStayFromSelectedObj={myStayFromSelectedObj}
                setMyStayFromSelectedObj={setMyStayFromSelectedObj}
                filterByActivity={filterByActivity}
                setfilterByActivity={setfilterByActivity}
              />
              {/* </CardHeader> */}
              {myActiveTab === "Reservations" ? (
                <OrderTableData
                  {...OrderTableDataProps}
                  inforStatus={filterSelected ? filterSelected.value : "In-house"}
                />
              ) : myActiveTab === "All CheckIn" ? (
                <AllCheckIn {...AllCheckInDataProps} />
              ) : myActiveTab === "My-Stay" ? (
                <MyStayTableData
                  {...OrderTableDataProps}
                  myStayStartDate={myStayStartDate}
                  setMyStayStartDate={setMyStayStartDate}
                  myStayEndDate={myStayEndDate}
                  setMyStayEndDate={setMyStayEndDate}
                  inforStatus={filterSelected ? filterSelected.value : false}
                  myStayFromSelectedObj={myStayFromSelectedObj}
                  filterByActivity={filterByActivity}
                  setMyCurrentPage={setMyCurrentPage}
                  searchText={searchText}
                  setPerPage={setPerPage}
                  perPage={perPage}
                  myActiveTab={myActiveTab}
                />
              ) : (
                <DailyCheckIn {...AllCheckInDataProps} />
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default MobileAppReservationContain;
